import React from "react";

const Home = () => {
  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <h2 className="hero-title animate-fade-up">
            Crafted for the Modern Individual
          </h2>
          <p className="hero-subtitle animate-fade-up">
            Premium clothing manufacturing with attention to detail and
            sustainable practices
          </p>
          <button
            className="btn-primary animate-fade-up"
            onClick={() =>
              document
                .querySelector(".about-section")
                .scrollIntoView({ behavior: "smooth" })
            }
          >
            Explore Our Craft
          </button>
        </div>
        <div className="hero-overlay"></div>
        <div
          className="hero-image"
          style={{
            backgroundImage:
              "url('https://images.unsplash.com/photo-1445205170230-053b83016050?ixlib=rb-4.0.3&auto=format&fit=crop&w=2071&q=80')",
          }}
        ></div>
      </section>

      {/* About Preview Section */}
      <section className="about-preview section-padding">
        <div className="container">
          <div className="section-header animate-fade-up">
            <h2>Our Philosophy</h2>
            <p>Creating timeless pieces with modern sensibilities</p>
          </div>
          <div className="about-preview-content">
            <div className="about-text animate-fade-left">
              <h3>Where Quality Meets Design</h3>
              <p>
                At Laiger, we believe clothing should be more than just
                fabric—it should be an expression of individuality. Each piece
                in our collection is meticulously designed and crafted to
                provide exceptional comfort, durability, and style.
              </p>
              <p>
                Our manufacturing process combines traditional techniques with
                innovative technology to create clothing that stands the test of
                time while remaining environmentally conscious.
              </p>
              <button
                className="btn-secondary"
                onClick={() => (window.location.hash = "#about")}
              >
                Learn More About Us
              </button>
            </div>
            <div className="about-image animate-fade-right">
              <div className="image-frame">
                <img
                  src="https://images.unsplash.com/photo-1523381210434-271e8be1f52b?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80"
                  alt="Laiger Manufacturing Process"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Collections Section */}
      <section className="collections section-padding">
        <div className="container">
          <div className="section-header animate-fade-up">
            <h2>Our Collections</h2>
            <p>Explore our premium range of clothing categories</p>
          </div>
          <div className="collections-grid">
            {[
              {
                id: 1,
                title: "Denim Collection",
                desc: "Premium jeans with superior fit and durability",
                image:
                  "https://images.unsplash.com/photo-1542272604-787c3835535d?ixlib=rb-4.0.3&auto=format&fit=crop&w=2026&q=80",
              },
              {
                id: 2,
                title: "Casual Shirts",
                desc: "Comfortable shirts for everyday wear",
                image:
                  "https://images.unsplash.com/photo-1596755094514-f87e34085b2c?ixlib=rb-4.0.3&auto=format&fit=crop&w=2068&q=80",
              },
              {
                id: 3,
                title: "Premium T-Shirts",
                desc: "Soft, breathable tees with lasting quality",
                image:
                  "https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?ixlib=rb-4.0.3&auto=format&fit=crop&w=2080&q=80",
              },
              {
                id: 4,
                title: "Sweaters & Knits",
                desc: "Warm, cozy knits for cooler seasons",
                image:
                  "https://images.unsplash.com/photo-1574180045827-681f8a1a9622?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80",
              },
              {
                id: 5,
                title: "Jackets & Outerwear",
                desc: "Stylish protection from the elements",
                image:
                  "https://images.unsplash.com/photo-1551028719-00167b16eac5?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80",
              },
              {
                id: 6,
                title: "Manufacturing Excellence",
                desc: "Behind the scenes of our production",
                image:
                  "https://images.unsplash.com/photo-1441986300917-64674bd600d8?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80",
              },
            ].map((collection) => (
              <div
                key={collection.id}
                className="collection-card animate-scale"
              >
                <div className="collection-image">
                  <img src={collection.image} alt={collection.title} />
                  <div className="collection-overlay">
                    <h4>{collection.title}</h4>
                    <p>{collection.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="testimonials section-padding">
        <div className="container">
          <div className="section-header animate-fade-up">
            <h2>Industry Recognition</h2>
            <p>What fashion experts say about our work</p>
          </div>
          <div className="testimonials-grid">
            {[
              {
                id: 1,
                name: "Fashion Forward Magazine",
                quote:
                  "Laiger represents the future of sustainable clothing manufacturing without compromising on style.",
                position: "Editorial Review",
              },
              {
                id: 2,
                name: "Style Insider",
                quote:
                  "The attention to detail in Laiger's collections sets a new standard in premium apparel manufacturing.",
                position: "Industry Report",
              },
              {
                id: 3,
                name: "Eco Fashion Council",
                quote:
                  "Their commitment to sustainable practices while maintaining quality is truly commendable.",
                position: "Sustainability Award 2023",
              },
            ].map((testimonial) => (
              <div
                key={testimonial.id}
                className="testimonial-card animate-fade-up"
              >
                <div className="quote-icon">"</div>
                <p className="testimonial-text">{testimonial.quote}</p>
                <div className="testimonial-author">
                  <h4>{testimonial.name}</h4>
                  <p>{testimonial.position}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Manufacturing Process */}
      <section className="process section-padding">
        <div className="container">
          <div className="section-header animate-fade-up">
            <h2>Our Manufacturing Process</h2>
            <p>From concept to finished product</p>
          </div>
          <div className="process-steps">
            {[
              {
                step: "01",
                title: "Design & Concept",
                desc: "Our designers create concepts focusing on both aesthetics and functionality.",
              },
              {
                step: "02",
                title: "Material Selection",
                desc: "We source sustainable, high-quality fabrics from trusted suppliers.",
              },
              {
                step: "03",
                title: "Pattern Making",
                desc: "Precision patterns are developed for optimal fit and minimal waste.",
              },
              {
                step: "04",
                title: "Quality Production",
                desc: "Skilled artisans construct each piece with meticulous attention to detail.",
              },
              {
                step: "05",
                title: "Quality Control",
                desc: "Every item undergoes rigorous inspection before leaving our facility.",
              },
              {
                step: "06",
                title: "Sustainable Packaging",
                desc: "Eco-friendly packaging ensures your clothing arrives perfectly.",
              },
            ].map((item, index) => (
              <div
                key={item.step}
                className="process-step animate-fade-up"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                <div className="step-number">{item.step}</div>
                <h4>{item.title}</h4>
                <p>{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
